import 'babel-polyfill'
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */


import Vue from 'vue';
import Vuetify from 'vuetify'
import FieldRules from './utils/FieldRules'
import CustomerDataGrid from './components/CustomerDataGrid'
import QuoteDataGrid from './components/QuoteDataGrid'
import QuoteItemForm from './components/QuoteItemForm'
import QuoteItemFormSimple from './components/QuoteItemFormSimple'
import ProductSelect from './components/ProductSelect'
import OrderInquiryDatagrid from './components/OrderInquiryDatagrid'

import "../sass/app.scss";
import '@fortawesome/fontawesome-free/scss/fontawesome.scss';
import '@fortawesome/fontawesome-free/scss/solid.scss';
import '@fortawesome/fontawesome-free/scss/regular.scss';


window.Vue = Vue;

Vue.use(Vuetify, {
    iconfont: 'fa4'
})

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

const files = require.context('./', true, /\.vue$/i)
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

//Vue.component('example-component', require('./components/ExampleComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
    data: {
        rules: FieldRules,
        drawer: false,
        quote_item: window.quote_item,
        available_products: window.available_products,
        accessory_categories: window.categories,
        accessories: window.accessories,
        old_form: typeof window.old_form == 'undefined' ? undefined : window.old_form,
        quote_items: window.quote_items,
        accessory: window.accessory,
        base_url: window.base_url,
        searchPo: window.po_search,
        csrf: window.csrf,
        has_errors: false,
        valid: true,
        valid_po_search: true,
        role_id: window.role_id,
        quote: {
            _ship_via: '',
            _shipping_speed: 'Standard Build (6 weeks)',
        },
        dialog_display: false,
        dialog_destination_url: null,
        dialog_title: null,
        dialog_description: null,
        dialog_loading: false,
        login_remember: false,
        disableDupe: false
    },
    created: function() {
        this.addFormEventListener('register_user');
        this.addFormEventListener('register_user_by_admin');
        this.addFormEventListener('create_new_quote');
    },
    methods: {
        'logoff': function() {
            document.getElementById('logout-form').submit();
        },
        'submitSearch': function() {
            document.getElementById('search').submit();
        },
        loadPage: function(url, action, label) {
            this.disableDupe = true;
            if (typeof action != 'undefined') {
                this.ga(action, label, function() {
                    document.location = url;
                });
            } else {
                document.location = url;
            }
        },
        confirmLoadPage: function(url, title, copy) {
            this.dialog_destination_url = url;
            this.dialog_title = title;
            this.dialog_description = copy;
            this.dialog_display = true;
        },
        confirmSubmitForm: function(id, title, copy) {
            this.dialog_title = title;
            this.dialog_description = copy;
            this.dialog_display = true;
        },
        submitOrderForm: function(id) {
            var elem = document.getElementById('form_submit_btn')
            elem.disabled=true;
            elem.children[0].textContent='SENDING…';
            document.getElementById(id).submit();
        },
        validate: function() {

            var elem = document.getElementById('form_submit_btn')
            var el_old_value = elem.children[0].textContent

            elem.disabled=true;
            elem.children[0].textContent='SENDING…';

            if (this.$refs.quoteitem_form.validate()) {
                this.has_errors = false;
                this.ga('submit-form', 'quoteitem_form', function() {
                    document.getElementById('quoteitem_form').submit();
                });
            } else {
                elem.disabled=false;
                elem.children[0].textContent=el_old_value;

                this.has_errors = true;
                this.$vuetify.goTo('#quote-item-form')
            }
        },
        getId: function(v) {
            if (typeof v == 'object') {
                return v.id;
            }
            return v;
        },
        searchPO: function() {
            if (this.$refs.po_searchform.validate()) {
                this.$refs.po_searchform.$el.submit();
            }
            //this.$refs['po_searchform'].submit();
        },
        ga: function(action, label, callback) {
            if (typeof callback != 'function') {
                callback = function() {};
            }
            if (typeof gtag != 'undefined') {
                window.dataLayer.push({
                    event: 'ga_event',
                    event_category: 'tutco-portal',
                    event_label: label,
                    event_action: action,
                    eventCallback: callback
                });

            } else {
                callback();
            }
        },
        addFormEventListener: function(id) {
            var g = this;
            var form = document.getElementById(id);
            if (form != null) {
                form.addEventListener('submit', function(event) {
                    event.preventDefault();
                    g.ga('submit-form', id, function() {
                        form.submit();
                    });
                });
            }
        }
    },
    components: {
        CustomerDataGrid,
        QuoteDataGrid,
        QuoteItemForm,
        QuoteItemFormSimple,
        ProductSelect,
        OrderInquiryDatagrid
    }
});
